// extracted by mini-css-extract-plugin
var _1 = "DocFlowProfileHeader-moduleprofileHeader__kFMO7 EntityProfileHeader-moduleEntityProfileHeader__q1KA3";
export { _1 as "profileHeader" }
